<template>
  <main-layout>
    <h1 class="title">Crea tipologia contratto</h1>
    <contract-type-form
      :submit-action="create"
      :fields="fields"
      redirect-route="contractTypes.show"
    />
  </main-layout>
</template>

<script>
import { call } from "vuex-pathify"

import ContractTypeForm from "@/components/ContractTypeForm.vue"
import MainLayout from "@/layouts/Main.vue"
import { fields } from "./fields"

export default {
  components: {
    ContractTypeForm,
    MainLayout
  },
  data() {
    return {
      fields,
      loading: true
    }
  },
  methods: {
    create: call("contractTypes/create")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
